module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Shopping/ATM-b334ea693eb1491c813f773d3be17ccf.svg";